<template>

  <LoadingSpinner v-if="!club"></LoadingSpinner>
  <div v-else class="container-fluid text-center" :class="{'non-member-formatting': false}" @click.prevent="selectedMember=null">
<!--    <pre>{{JSON.stringify(club, null, 2)}}</pre>-->

    <!--  marked for deletion card -->
    <div v-if="(userRole === 'owner') && markedForDeletion" class="card mol-center-card-width mol-color-theme-oscar-pool marked-for-deletion-card">
      <div class="card-header">
        <h4><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Oscar Pool Marked For Deletion</h4>
      </div>

      <div class="card-body">
        <p>This pool is currently marked to be deleted in {{timeToLiveText}}.</p>
        <button class="btn btn-sm btn-danger" type="button" @click.prevent="setMarkedForDeletion(false)">
          <i class="fa fa-undo"></i> Undo
        </button>
      </div>
    </div>

    <!-- club title card -->
    <div class="card mol-center-card-width mol-color-theme-oscar-pool club-title-card">
      <div class="card-body">
        <router-link v-if="userHasAdminPrivileges && !markedForDeletion" class="edit-club-button" :to="`/edit-oscar-pool/${club._id}`" href="#" title="edit club">
          <i class="fa fa-pencil-square-o"></i>
        </router-link>

        <div class="club-id">{{club._id}}</div>
<!--        <ProfileFilmsViewedGraphic class="profile-films-viewed-graphic" :viewed_array=club.viewed width="100%" height="100%" color="#DCD2A8"></ProfileFilmsViewedGraphic>-->
        <div class="club-title-info-layered-over-graphic">
          <ClubPicture :club="club" size="100"></ClubPicture>
          <div class="name-text">{{club.name}}</div>
          <div class="description-text">{{club.description}}</div>
          <br>
          <div v-if="userRoleTitleCardHtml" v-html="userRoleTitleCardHtml" class="role-text"></div>
        </div>
      </div>
    </div>

    <!--  members to approve card -->
    <div v-if="(pending_members.length > 0) && !markedForDeletion" class="card mol-center-card-width mol-color-theme-oscar-pool pending-members-card">
      <div class="card-header">
        <h4>Contestants Pending Approval</h4>
      </div>

      <div class="card-body">
        <div v-for="member in pending_members" :key="member._id" class="pending-member">
          <span class="badge rounded-pill bg-danger"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
          <div class="member-name">
            <ProfilePicture :user="member" :size="20"></ProfilePicture> <ProfileName :user="member"></ProfileName>
          </div>

          <div class="join-request-response-buttons">
            <button class="btn btn-sm btn-outline-danger" type="button" @click="dismissUserJoinRequest(member._id)">
              <i class="fa fa-times"></i> Dismiss
            </button>
            <button class="btn btn-sm btn-success" type="button" @click="acceptUserJoinRequest(member._id)">
              <i class="fa fa-check"></i> Approve
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  results card -->
    <div v-if="currentOscarPool.active" class="card mol-center-card-width mol-color-theme-oscar-pool oscar-pool-card">
<!--
      <div class="card-header">
        <h4>Oscar Pool Results</h4>
      </div>
-->

      <div class="card-body">

        <div v-if="ceremonyState === 'after-ceremony'">
          <p><b>See the final results of your Oscar Pool.</b></p>
        </div>

        <div v-else>
          <p><b><i class="fa fa-bolt"></i> Watch live leaderboard updates during the ceremony.</b></p>
        </div>

        <router-link class="btn btn-mol" :to="`/oscar-pool/${club._id}/oscar-pool-results/98`">
<!--          <img :src="`${$imagePathBase}place-ribbon-white.svg`" class="rank-image"/> <span v-text="(ceremonyState === 'pre-ceremony') ? 'Preview Results Page' : 'Go To Results Page'"></span>-->
          <img :src="`${$imagePathBase}place-ribbon-white.svg`" class="rank-image"/> <span v-text="(ceremonyState === 'pre-ceremony') ? 'Preview Results Page' : 'Go To Results Page'"></span>
        </router-link>
      </div>
    </div>


    <!-- setup card -->
    <div v-if="!currentOscarPool.active && userHasAdminPrivileges" class="card mol-center-card-width mol-color-theme-oscar-pool oscar-pool-card">
      <span class="badge rounded-pill bg-danger"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
      <div class="card-header">
        <h4>Ballot Scoring Setup</h4>
      </div>

      <div class="card-body">
        <p>Before contestants can fill out their ballots, you or another admin must set your scoring parameters and launch the pool.</p>
        <p>You can learn about our scoring setup <router-link class="mol-subtle-link" to="/oscar-pool/about#running-a-pool-scoring-setup">here</router-link>.</p>
        <router-link class="btn btn-mol" :to="`/oscar-pool/${club._id}/oscar-pool-setup`">Oscar Pool Setup</router-link>
      </div>
    </div>

    <!-- ballot card (only seen if not showing setup card) -->
    <div v-else class="card mol-center-card-width mol-color-theme-oscar-pool oscar-pool-card">
      <div class="card-header">
        <h4>
          <AchievementRing
              class="selections-made-achievement-ring"
              :total_segments="numVotesTotal"
              :filled_segments="numVotesCast"
              size="25px"
              :center_img="achievementRingCenterImg"
          ></AchievementRing>
          Your Ballot
        </h4>
      </div>

      <div class="card-body">
        <!-- not launched yet -->
        <div v-if="!currentOscarPool.active">
          Once scoring has been set up by a pool admin, access to your ballot will be available here.
        </div>

        <div v-else>

          <template v-if="ceremonyState === 'pre-ceremony'"> <!--only show ballot explaination pre-ceremony-->
            <div v-if="!numVotesCast">
              <p>Your ballot is ready to fill out.<br>You've got until Oscar night to complete it.</p>
            </div>

            <div v-else-if="numVotesCast < numVotesTotal">
              <p>You've filled out <b>{{Math.trunc((numVotesCast * 100) / numVotesTotal)}}%</b> of your ballot.<br>
              You've got until Oscar night to complete it.</p>
            </div>

            <div v-else>
              <p><b>Your ballot is complete.</b><br>You've got until Oscar night to make changes.</p>
            </div>
          </template>

          <router-link class="btn btn-outline-mol" :to="`/oscar-pool/${club._id}/oscar-pool-ballot/${currentOscarPool._id}`">
            <i class="fa fa-check-square-o" aria-hidden="true"></i> Your Ballot
          </router-link>

          <OscarPoolCountdown
              v-if="currentOscarPool.active"
              class="oscar-pool-countdown"
              :club_id="club._id"
              :force_lock="ceremonyState !== 'pre-ceremony'"
          ></OscarPoolCountdown>

        </div>
      </div>
    </div>

    <!-- contestants card -->
    <div class="card mol-center-card-width mol-color-theme-oscar-pool club-members-card">
      <div class="card-header">
        <a v-if="!markedForDeletion" class="add-member-button" href="#" title="invite new member" @click.prevent="showInviteModal">
          <i class="fa fa-user-plus"></i>
        </a>
        <h4>Contestants</h4>
      </div>

      <div class="card-body">
        <p class="text-center">Ranked by number of this year's<br>nominated films viewed.</p>
        <table class="most-viewed-leaderboard-table">
          <thead>
          <tr>
            <th class="role-column"></th>
            <th class="films-column">films</th>
            <th class="name-column"></th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="member in mostViewedLeaderboard" :key="member._id">
            <td class="roll-column">
              <i v-if="member.role === 'owner'" class="fa fa-star"></i>
              <i v-if="member.role === 'admin'" class="fa fa-sliders"></i>
            </td>
            <td class="films-column"
                data-bs-toggle="tooltip"
                data-bs-custom-class="mol-tooltip"
                data-bs-html="true"
                :title="filmsViewedTooltipHtml(member._id)"
            >
              {{member.filmsViewedInCurrentPool.length}}
            </td>
            <td>
              <ClubMember
                  :club_id="club._id"
                  :member="member"
                  :user_role="userRole"
                  :show_buttons="isMemberSelected(member._id)"
                  @club-updated="updateClub()"
                  @click.stop="onMemberSelected(member._id)"
              ></ClubMember>
            </td>

          </tr>
          </tbody>
        </table>

        <div v-if="showInviteFirstMemberMessage" class="note-to-club-owner">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <span v-if="pending_members.length"> Approve a pending member to make them a member of your club.</span>
          <span v-else> Invite friends, family, coworkers or anyone to be a contestant in your Oscar Pool.</span>
        </div>

      </div>

      <div class="card-footer role-legend">
        <span class="roll-legend-span"><i class="fa fa-star"></i> pool owner</span>
        &nbsp;&nbsp;&nbsp;
        <span class="roll-legend-span"><i class="fa fa-sliders"></i> pool admin</span>
      </div>

    </div>

    <GenericModal v-if="show_code_modal" @modal-closed="show_code_modal=false">
      <template #header>
        <h6>share link to invite new contestant</h6>
      </template>

      <div style="text-align: center">
        <QRCodeVue3 :value="invite_link"
                    :width="250" :height="250"
                    :image="$imagePathBase + 'logo-64.png'"
                    :imageOptions="{margin: 2, imageSize: 0.25}"
                    :dotsOptions="{type: 'extra-rounded'}"
                    :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
        />
        <div class="d-grid gap-2">
          <button class="btn btn-sm btn-block btn-outline-success copy-invite-link-button" type="button" @click="copyLinkToClipboard">
            <span v-if="!textCopied">copy invite link<br><span style="opacity: 50%;">{{invite_link}}</span></span>
            <span v-else>copied!</span>
          </button>
        </div>
      </div>

    </GenericModal>

  </div>

</template>


<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import axios from "axios";
// eslint-disable-next-line
import ProfilePicture from "@/components/profile/ProfilePicture.vue";
import ProfileName from "@/components/profile/ProfileName.vue";
import GenericModal from "@/components/modal/GenericModal.vue";
import QRCodeVue3 from "qrcode-vue3";
import analytics from "@/analytics";
import {userStore} from "@/userStore";
import ClubMember from "@/components/clubs/ClubMember.vue";
import ClubPicture from "@/components/clubs/ClubPicture.vue";
import AchievementRing from "@/components/achievements/AchievementRing.vue";
import OscarPoolCountdown from "@/components/clubs/oscar pool/OscarPoolCountdown.vue";
//import ProfileFilmsViewedGraphic from "@/components/profile/ProfileFilmsViewedGraphic.vue";

export default {
  name: "ClubProfilePage",
  // eslint-disable-next-line
  components: {
    OscarPoolCountdown,
    AchievementRing,
    //ProfileFilmsViewedGraphic,
    ClubPicture, ClubMember, QRCodeVue3, GenericModal, ProfileName, ProfilePicture, LoadingSpinner},
  props: ['club_id'],
  data() {
    return {
      clubInfo: null,
      currentOscarPool: null,
      mostViewedLeaderboard: null,
      show_code_modal: false,
      show_code_time: 0,
      textCopied: false,
      selectedMember: null,
      timeToLiveText: null,
      ttlUpdateInterval: null,
      ceremonyState: null,
    }
  },
  async created() {
    return Promise.all([
      this.getCeremonyState(),
      this.updateClub()
    ]);
  },
  unmounted() {
    if ( this.ttlUpdateInterval ) {
      clearInterval(this.ttlUpdateInterval);
      this.ttlUpdateInterval = null;
    }
  },
  watch: {
    show_code_modal(newValue) {
      if ( newValue ) {
        this.show_code_time = Date.now();
      } else {
        const elapsedTime = Date.now() - this.show_code_time;
        analytics.sendEvent('club_invite_code_viewed', {
          seconds: elapsedTime / 1000
        });
      }
    },

    clubInfo(/*newValue*/) {
      this.selectedMember = null;
    }
  },
  computed: {
    userStore() {
      return userStore;
    },
    invite_link() {
      return `${location.origin}/join-oscar-pool/${this.club_id}`;
    },
    club() {
      return this.clubInfo?.club;
    },
    members() {
      return this.clubInfo?.club.members?.filter(m => (m.role !== 'pending')) || [];
    },
    pending_members() {
      return this.clubInfo?.club.members?.filter(m => (m.role === 'pending')) || [];
    },
    owners() {
      return this.members.filter(m => (m.role === 'owner')) || [];
    },
    admin_members() {
      return this.members.filter(m => (m.role === 'admin')) || [];
    },
    non_admin_members() {
      return this.members.filter(m => !((m.role === 'admin') || (m.role === 'owner'))) || [];
    },
    user_membership() {
      return this.club.members?.find(m => m._id === userStore.getUserId());
    },
    userRole() {
      return this.user_membership?.role;
    },
    userHasAdminPrivileges() {
      return (this.userRole === 'owner') || (this.userRole === 'admin');
    },
    userRoleTitleCardHtml() {
      switch ( this.userRole ) {
        case 'owner':
          return `<i style='font-size: 80%;' class="fa fa-star"></i> you are the <b>owner</b> of this pool`;
        case 'admin':
          return `<i class="fa fa-sliders"></i> you are an <b>admin</b> of this pool`;
      }
      return null;
    },
    markedForDeletion() {
      return this.club.marked_for_deletion;
    },
    showAppointFirstAdminMessage() {
      return (this.userRole === 'owner') && this.non_admin_members.length && !this.admin_members.length;
    },
    showInviteFirstMemberMessage() {
      return (this.userRole === 'owner') && !this.non_admin_members.length && !this.admin_members.length;
    },
    numVotesTotal() {
      return this.currentOscarPool.category_points.length * (this.currentOscarPool.second_choice_enabled? 2 : 1);
    },
    numVotesCast() {
      if ( !this.myBallot ) {
        return 0;
      }
      return this.myBallot.choices.length + (this.currentOscarPool.second_choice_enabled? this.myBallot.second_choices.length : 0);
    },
    achievementRingCenterImg() {
      return ( this.numVotesTotal === this.numVotesCast ) ?
          'achievements/ballot-box.svg' : 'achievements/disabled/ballot-box.svg';
    },
    myBallot() {
      return this.currentOscarPool.ballots.find(b => b.user === userStore.getUserId())
    }
  },
  methods: {
    showInviteModal() {
      this.show_code_modal = true;
      this.textCopied = false;
    },
    copyLinkToClipboard() {
      navigator.clipboard.writeText( this.invite_link );
      this.textCopied = true;
      analytics.sendEvent('club_invite_code_copied');
    },
    onMemberSelected(_member_id) {
      this.selectedMember = !this.markedForDeletion && (this.isMemberSelected(_member_id)? null : _member_id);
    },
    isMemberSelected(_member_id) {
      return !this.markedForDeletion && (this.selectedMember === _member_id);
    },
    async getCeremonyState() {
      return axios.get("/api/club/oscar-pool/ceremony-state")
          .then(response => {
            this.ceremonyState = response.data.ceremonyState;
          });
    },
    async updateClub() {

      if ( this.ttlUpdateInterval ) {
        clearInterval(this.ttlUpdateInterval);
        this.ttlUpdateInterval = null;
      }

      axios.get(`/api/club/${this.club_id}/oscar-pool/club-info`)
          .then(response => {
            //console.log(`GET /api/club/${this.club_id}/oscar-pool/club-info`, response.data);
            this.clubInfo = response.data.club_info;
            this.currentOscarPool = response.data.oscar_pools[0];

            if ( this.clubInfo.club.marked_for_deletion ) {
              this.clubInfo.club.marked_for_deletion = new Date(this.clubInfo.club.marked_for_deletion);
              this.updateTimeToLiveText();
              this.ttlUpdateInterval = setInterval(this.updateTimeToLiveText, 1000);
            }

            // if I'm not a member of this club, reroute to the join page
            if ( !this.clubInfo.my_membership || (this.clubInfo.my_membership.role === 'pending') ) {
              this.$router.push({name: 'OscarPoolJoinPage', params: {club_id: this.clubInfo.club._id}});
            }

            // sort members by number of films they've viewed
            this.clubInfo.club.members.sort((memberA, memberB) => {
              return memberB.viewedCount - memberA.viewedCount;
            });

            //console.log('this.currentOscarPool', this.currentOscarPool);
            this.mostViewedLeaderboard = this.clubInfo.club.members.filter(m => m.role !== 'pending').map(member => {
              const filmsViewedInCurrentPool = this.currentOscarPool.viewedByContestants.find(viewedObj => viewedObj.user_id === member._id)?.viewed || [];
              member.viewedCount = undefined;
              return {
                ...member,
                filmsViewedInCurrentPool: filmsViewedInCurrentPool
              };
            });

            this.mostViewedLeaderboard.sort((memberA, memberB) => {
              return memberB.filmsViewedInCurrentPool.length - memberA.filmsViewedInCurrentPool.length;
            });

          })
          .catch(err => {
            console.log(err);
            // problem finding the club? go to the clubs page
            this.$router.push({name: 'OscarPoolsPage'}); // todo: add ClubNotFound page?
          });
    },
    async acceptUserJoinRequest(_pending_member_id) {
      return axios.post(`/api/club/resolve-join-request`, {
        club_id: this.club._id,
        pending_member_id: _pending_member_id,
        approved: true
      })
          .then(response => {
            //console.log('response.data', response.data);
            userStore.setUser(response.data);
            this.updateClub();
          })
          .catch(err => {
            console.log(err);
          });
    },

    async dismissUserJoinRequest(_pending_member_id) {
      return axios.post(`/api/club/resolve-join-request`, {
        club_id: this.club._id,
        pending_member_id: _pending_member_id,
        approved: false
      })
          .then(response => {
            userStore.setUser(response.data);
            this.updateClub();
          })
          .catch(err => {
            console.log(err);
          });
      },

    async removeMember(_member) {
      //console.log(`removeUser( ${_member.username} )`, _member);

      return this.askForConfirmation(`Remove ${_member.username} from ${this.club.name}?`)
          .then(confirmed => {
            if ( !confirmed ) {
              return null;
            }
            return axios.post(`/api/club/remove`, {
              club_id: this.club._id,
              member_id: _member._id
            });
          })
          .then(response => {
            if ( response ) {
              this.clubInfo = response.data;
            }
          })
          .catch(err => {
            console.log(err);
          });
    },

    async setMarkedForDeletion(_set) {
      return axios.post(`/api/club/mark-for-delete`, {
        club_id: this.club._id,
        mark: !!_set
      })
          .then(response => {
            if ( response ) {
              this.clubInfo = response.data;
            }
          })
          .catch(err => {
            console.log(err);
          });
    },

    updateTimeToLiveText() {

      if ( !this.markedForDeletion ) {
        return this.timeToLiveText = null;
      }
       const msToLive = this.markedForDeletion.getTime() - Date.now();
      if ( msToLive < 0 ) {
        return this.timeToLiveText = '<1m';
      }

      const msPerSecond = 1000;
      const msPerMinute = 60 * msPerSecond;
      const msPerHour = 60 * msPerMinute;
      const msPerDay = 24 * msPerHour;

      const daysToLive = Math.floor(msToLive / msPerDay);
      const hoursToLive = Math.floor( (msToLive - (daysToLive * msPerDay)) / msPerHour );
      const minutesToLive = Math.floor( (msToLive - ((daysToLive * msPerDay) + (hoursToLive * msPerHour))) / msPerMinute );
      //const secondsToLive = Math.floor( (msToLive - ((daysToLive * msPerDay) + (hoursToLive * msPerHour) + (minutesToLive * msPerMinute))) / msPerSecond );

      this.timeToLiveText = (() => {
        let result = '';
        result += daysToLive ? `${daysToLive}d` : '';
        result += hoursToLive ? ` ${hoursToLive}h` : '';
        result += minutesToLive ? ` ${minutesToLive}m` : '';
        result += (msToLive < msPerMinute) ? '<1m' : '';
        return result.trim();
      })();
    },

    filmsViewedTooltipHtml(_user_id) {

      const member = this.mostViewedLeaderboard.find(m => m._id === _user_id);
      if ( !member ) {
        return '';
      }

      const filmTitles = member.filmsViewedInCurrentPool.map(film_id => {
        const filmInfo = this.currentOscarPool.filmInfo.find(fi => fi._id === film_id);
        return filmInfo.name;
      });

      return filmTitles.reduce((accTooltipText, curFilmTitle) => {
        return `${accTooltipText}${accTooltipText? '<br>' : ''}<i class="fa fa-check-square-o" aria-hidden="true"></i> <i>${curFilmTitle}</i>`;
      }, '');
    }

  }
}
</script>


<style scoped>

.container-fluid {
  padding-top: 10px;
  &.non-member-formatting {
    padding-top: 60px;
    max-height: 1250px;
    overflow: hidden;
  }
}

.card-header {
  padding-top: 16px;
  padding-bottom: 0;
  background-color: inherit;
  border: none;

  .btn-show-more {
    background-color: inherit;
    top: 0;
  }

  hr {
    margin-bottom: 0;
  }
}

.card-footer {
  background-color: inherit;
  border: none;
}

.club-title-card {
  isolation: isolate;
  overflow: hidden;

  margin-top: 20px;
  /*padding: 10px;*/

  .profile-films-viewed-graphic {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .club-id {
    font-size: xx-small;
    position: absolute;
    top: 1em;
    left: 1em;
    opacity: 50%;
  }

  .name-text {
    display: block;
    margin-top: 0.5em;
    font-weight: 600;
    font-size: x-large;
  }

  .role-text {
    color: var(--bs-secondary);
    font-style: italic;
    font-size: 80%;
  }

  .club-title-info-layered-over-graphic {
    .name-text {
      display: block;
      margin-top: 0.5em;
      font-weight: 600;
      font-size: x-large;
    }
  }


  .edit-club-button {

    color: var(--mol-color-gold);
    float: right;
    width: fit-content;

    &:hover {
      color: var(--mol-color-win-icon);
    }
  }
}

.pending-members-card {

  margin-top: 20px;
  margin-bottom: 20px;

  .badge {
    position: absolute;
    margin-top: -1.5em;
    margin-left: -1.5em;
    animation: pulse-animation 2s infinite;
    z-index: 1;
  }

  .card-body {
    text-align: left;

    .pending-member {
      &:not(:first-of-type) {
        margin-top: 20px;
      }

      position: relative;
      /*display: flex;*/
      padding: 10px;
      border-style: solid;
      border-width: 0.1px;
      border-radius: 5px;

      height: fit-content;
      width: 100%;

      .member-name {
        flex: 1;
        margin-top: auto;
        margin-bottom: 0.75em;
      }

      .join-request-response-buttons {
        /*float: right;*/
        /*display: inline-block;*/

        position: relative;
        text-align: right;

        button {
          font-size: 80%;

          &:not(:first-of-type) {
            margin-left: 0.5em;
          }
        }
      }
    }
  }
}

.oscar-pool-card {
  margin-top: 20px;
  margin-bottom: 20px;

  .badge {
    height: 1.875em;
    width: 1.875em;
    position: absolute;
    margin-top: -8px;
    margin-left: -8px;
    animation: pulse-animation 2s infinite;
    z-index: 1;
  }

}

.club-members-card {
  margin-top: 20px;
  margin-bottom: 20px;

  .card-body {
    padding-right: 20px;
    padding-left: 20px;
    /*columns: 3 auto;*/
    text-align: left;

    .member-type-div {
      margin-bottom: 30px;
    }
  }

  .add-member-button {
    color: var(--mol-color-gold);
    float: right;
    width: fit-content;

    &:hover {
      color: var(--mol-color-win-icon);
    }
  }

  .note-to-club-owner {
    color: var(--bs-secondary);
    font-style: italic;
    font-size: smaller;
    margin-top: 2em;
    margin-left: 1em;
  }
}

.marked-for-deletion-card {
  margin-top: 20px;
  margin-bottom: 20px;
}

.copy-invite-link-button {
  margin-top: 2em;
}

.most-viewed-leaderboard-table {
  width: 100%;
}


@keyframes pulse-animation {
  0% { box-shadow: 0 0 0 0px rgba(255, 127, 80, 0.4); }
  100% { box-shadow: 0 0 0 15px rgba(255, 127, 80, 0); }
}

table {

  thead {
    tr {

      .films-column, .name-column {
        border-style: none none solid none;
        border-width: 0.1px;
        border-color: var(--mol-color-gold-faded);
      }

    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color: color-mix(in srgb, var(--mol-color-gold-background), var(--mol-color-gold) 10%)
      }
    }
  }

  th, td {
    font-size: small;

    &.films-column {
      text-align: center;
      width: 1%;
    }

    &.roll-column {
      font-size: xx-small;
      text-align: center;
      width: 1%;
    }

    .name-column {
    }

  }

}

.films-viewed-tooltip-text {
  color: red;
}

.role-legend {
  margin-right: 0;
  margin-left: auto;
  width: fit-content;
  font-size: x-small;
  text-align: right;

  .fa-star {
    font-size: 80%;
  }
}

.oscar-pool-countdown {
  margin-top: 0.75em;
  /*font-size: smaller;*/
}

.rank-image {
  height: 1.5em;
}

</style>